const ONE_MINUTE = 60 * 1000
const ONE_HOUR = ONE_MINUTE * 60
const THREE_HOURS = ONE_HOUR * 3
const ONE_DAY = ONE_HOUR * 24
const THREE_DAYS = ONE_DAY * 3
const ONE_WEEK = ONE_DAY * 7
const ONE_YEAR = ONE_DAY * 365

module.exports = {
    ONE_MINUTE,
    ONE_HOUR,
    THREE_HOURS,
    ONE_DAY,
    THREE_DAYS,
    ONE_WEEK,
    ONE_YEAR,
}
